export const SUBMISSION_ERROR = "SUBMISSION_ERROR";
export const getSubmissionError = (data) => {
    return {
        type: SUBMISSION_ERROR,
        payload: data
    }
}